import React from 'react'

import { SignupTypeSelectionUI, SignupTypeOption } from '~/components/screens/SignupTypeSelectionUI'
import {
  SignupType,
  useBffWebOnboardingSignupTypeSelection,
  useSignupTypeSelectionOptions,
} from '../utils'
import { logEvent } from '~/utils/events'

/**
 * Authenticated user type selection screen.
 * Fetches available options from BFF and calls BFF endpoint to save signup type.
 */
const AuthenticatedSignupTypeSelection: React.FC = () => {
  const signupTypeSelection = useBffWebOnboardingSignupTypeSelection()
  const { data: options, isLoading: optionsLoading } = useSignupTypeSelectionOptions()

  const handleSelectOption = async (option: SignupTypeOption) => {
    const signupType = option.value as SignupType

    if (signupType === SignupType.HEALTH_PLAN_MEMBER) {
      logEvent('USER_SELECTED_ENROLLED_HEALTH_PLAN', {})
    } else if (signupType === SignupType.HEALTH_PLAN_PROSPECT) {
      logEvent('USER_SELECTED_CONSIDERING_HEALTH_PLAN', {})
    } else if (signupType === SignupType.CARE_ONLY_MEMBER) {
      logEvent('USER_SELECTED_VIRTUAL_CARE_ONLY', {})
    }

    await signupTypeSelection.handler(signupType)
  }

  const handleNoInsurance = async () => {
    logEvent('USER_SELECTED_NO_INSURANCE', {})
    await signupTypeSelection.handler('other')
  }

  return (
    <SignupTypeSelectionUI
      options={options}
      onSelectOption={handleSelectOption}
      onNoInsurance={handleNoInsurance}
      isLoading={signupTypeSelection.loading || optionsLoading}
    />
  )
}

export default AuthenticatedSignupTypeSelection
